import { useCallback } from 'react';
import type { OrganizationEntityType } from '../models';

export const useGetOrganizationEntityName = () =>
  useCallback(({ entityType }: { entityType: OrganizationEntityType }) => {
    switch (entityType) {
      case 'communities':
        return 'Communities';
      case 'givings':
        return 'Giving';
      case 'programs':
        return 'Programs';
      case 'videos':
        return 'Videos';
    }
  }, []);
